import React, { Component } from 'react';
import change2 from 'assets/icons/icon-change-meal.svg';
import isFav from 'assets/icons/favourites/is-fav.svg';
import { withLocale } from '@dietlabs/components';
import withGTM from 'view/GoogleTagManager/withGTM';
import PropTypes from 'prop-types';
import { EVENT_CATEGORY_DIET_PLAN } from 'view/GoogleTagManager/EventCategories';
import withFirebase from 'view/FirebaseAnalytics/withFirebase';

class DayPlanMealReplacement extends Component {
    static propTypes = {
        mealReplacement: PropTypes.shape({
            id: PropTypes.number.isRequired,
            dishes: PropTypes.arrayOf(PropTypes.shape()).isRequired,
        }).isRequired,
        trackEvent: PropTypes.func.isRequired,
        replaceMeal: PropTypes.func.isRequired,
        originalMealId: PropTypes.number.isRequired,
        mealKey: PropTypes.string.isRequired,
        closeAndScroll: PropTypes.func.isRequired,
        replaceMealSuccess: PropTypes.func.isRequired,
        isFavorited: PropTypes.bool.isRequired,
        trackFirebaseEvent: PropTypes.func.isRequired,
        dietPhase: PropTypes.string.isRequired,
        mealCategory: PropTypes.string.isRequired,
    };

    changeMeal = async () => {
        this.props.trackEvent(EVENT_CATEGORY_DIET_PLAN, 'exchange meal');
        this.props.closeAndScroll();

        const replacement = {
            originalMealId: this.props.originalMealId,
            replacementId: this.props.mealReplacement.id,
            key: this.props.mealKey,
            dishes: this.props.mealReplacement.dishes,
        };

        const response = await this.props.replaceMeal(replacement);

        if (
            response.data.me.dietSetReplaceMeal.__typename !==
            'BasicMutationSuccess'
        ) {
            throw new Error(
                `Replace meal failed: ${response.data.me.dietSetReplaceMeal.__typename}`
            );
        }

        this.props.trackFirebaseEvent('user_action', {
            action: 'tap-change_meal',
            location: 'Change_meal',
            meal_id: this.props.mealReplacement.id,
            meal_category: this.props.mealCategory,
            diet_phase: this.props.dietPhase,
            meal_favourites: this.props.isFavorited,
        });

        this.props.replaceMealSuccess();
    };

    render() {
        const mealReplacement = this.props.mealReplacement;
        let i = 0;
        return (
            <li>
                <button
                    className="text-left px-0"
                    type="button"
                    onClick={() => this.changeMeal()}
                    data-test="replace-meal"
                >
                    {this.props.isFavorited && (
                        <img
                            src={isFav}
                            className="fav-icon"
                            alt="Favourite Meal"
                        />
                    )}

                    {mealReplacement.dishes.map(dish => {
                        i += 1;
                        return (
                            <span key={dish.id}>
                                {i >= 2 ? ', ' : ''}
                                {dish.name}
                            </span>
                        );
                    })}

                    <span className="stay-together">
                        <span className="btn-change">
                            <img
                                className="img-fluid img-sup"
                                src={change2}
                                alt="{this.props.t('meal/exchange-ingredient')}"
                            />
                        </span>
                    </span>
                </button>
            </li>
        );
    }
}

export { DayPlanMealReplacement };
export default withFirebase(withGTM(withLocale(DayPlanMealReplacement)));
